<template>
	<v-container class="mb-10">
		<v-row>
			<v-col cols="12" class="my-0 pt-2 pb-0">
				<v-stepper v-model="step" flat>
					<v-col offset-sm="3" cols="12" sm="6" class="my-0 py-0">
						<v-stepper-header class="v-card--flat">
							<v-stepper-step :complete="step > 1" step="1" editable color="primary">
								Itens
							</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step :complete="step > 2" step="2" :editable="isAssinaturaAtiva">
								Assinatura
							</v-stepper-step>
							<v-divider></v-divider>
							<v-stepper-step step="3" :editable="isFinalizarAtivo"> Finalizar</v-stepper-step>
						</v-stepper-header>
					</v-col>
					<v-col cols="12" class="my-0 py-0">
						<v-stepper-items>
							<v-stepper-content step="1">
								<etapa-itens-anuencia
									data-testid="etapa-itens-anuencia"
									@ir-para-assinatura="irParaAssinatura"
									@ir-para-finalizar="irParaFinalizar"
									@atualizar-steper="atualizarSteper"
								></etapa-itens-anuencia>
							</v-stepper-content>
							<v-stepper-content step="2">
								<etapa-assinatura-anuencia
									v-if="isAssinaturaAtiva"
									data-testid="etapa-assinatura-anuencia"
									:etapa="Number(step)"
									@ir-para-finalizar="irParaFinalizar"
								></etapa-assinatura-anuencia>
							</v-stepper-content>
							<v-stepper-content step="3">
								<etapa-finalizar-anuencia
									data-testid="etapa-finalizar-anuencia"
									v-if="isFinalizarAtivo"
								></etapa-finalizar-anuencia>
							</v-stepper-content>
						</v-stepper-items>
					</v-col>
				</v-stepper>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import EtapaItensAnuencia from '@/views/pages/adesao/anuenciaFornecedor/itens/EtapaItensAnuencia.vue'
import EtapaFinalizarAnuencia from '@/views/pages/adesao/anuenciaFornecedor/finalizar/EtapaFinalizarAnuencia.vue'
import buscarAnuencia from '@/views/pages/adesao/anuenciaFornecedor/mixin/buscar-anuencia-mixin'
import EtapaAssinaturaAnuencia from '@/views/pages/adesao/anuenciaFornecedor/assinatura/EtapaAssinaturaAnuencia.vue'

export default {
	name: 'anuencia-fornecedor-view',
	components: { EtapaAssinaturaAnuencia, EtapaItensAnuencia, EtapaFinalizarAnuencia },
	mixins: [buscarAnuencia],
	data() {
		return {
			step: 1,
			anuencia: {},
		}
	},
	computed: {
		isFinalizarAtivo() {
			return this.estaRecusada || this.estaAssinado || this.finalizado
		},
		isAssinaturaAtiva() {
			return (this.estaAceita || this.estaAssinado || this.finalizado) && (!this.anuencia.justificativaRecusa) && (!this.anuencia.isDocumentoGeradoErro)
		},
	},
	methods: {
		async irParaFinalizar() {
			await this.buscarDadosCabecalho()
			this.step = 3
		},
		async irParaAssinatura() {
			await this.buscarDadosCabecalho()
			this.step = 2
		},
		async atualizarSteper() {
			await this.buscarDadosCabecalho()
		},
	},
}
</script>
<style scoped lang="stylus">
.cabecalho
	color white
	background-color var(--v-primary-base)
	display flex
	justify-content start
	padding 20px
	border-radius 10px 10px 0 0

	.informacoes
		display flex
		flex-direction row
		justify-content flex-start
		gap 50px
		flex-wrap wrap
		width 70%

		.informacao
			display flex
			flex-direction column

			.titulo
				font-weight bold
				font-size 0.75em

			.valor
				font-size 0.8em

	.acoes
		width 30%
		display flex
		flex-direction row
		justify-content flex-end
		gap 20px

@media screen and (max-width: 768px)
	.cabecalho
		display flex
		flex-direction column
		height auto

		.informacoes
			display flex
			flex-direction column
			width 100%
			height auto
			font-size 1.8em
			align-items flex-start
			align-content stretch
			gap 10px

		.acoes
			display flex
			flex-direction column
			width 100%
			height auto
			jusfity-content center
			heigth auto
			justify-items center
</style>
